import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { INSTRUMENTS } from "@/data/brokers";
import { SIGNALS } from "@/data/signals";
import { Building2, LineChart, Radio, FileText } from "lucide-react";
import { useBrokers } from "@/context/BrokersContext";

const PAGES = [
  { label: "Broker finder", to: "/brokers/finder" }, { label: "Broker directory", to: "/brokers" }, { label: "Compare brokers", to: "/brokers/compare" },
  { label: "Swap intelligence", to: "/swaps" }, { label: "Trading signals", to: "/signals" }, { label: "About & methodology", to: "/about" },
];

export const SearchDialog = ({ open, onOpenChange }) => {
  const nav = useNavigate();
  const { brokers: BROKERS } = useBrokers();
  const go = (to) => { onOpenChange(false); nav(to); };
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search brokers, instruments, signals…" data-testid="search-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Brokers">
          {BROKERS.map((b) => <CommandItem key={b.slug} value={b.name} onSelect={() => go(`/brokers/${b.slug}`)} data-testid={`search-broker-${b.slug}`}><Building2 size={14} className="mr-2 text-[var(--ink-3)]" />{b.name}</CommandItem>)}
        </CommandGroup>
        <CommandGroup heading="Instruments (swap rates)">
          {INSTRUMENTS.map((i) => <CommandItem key={i.id} value={i.label} onSelect={() => go(`/swaps?instrument=${i.id}`)}><LineChart size={14} className="mr-2 text-[var(--ink-3)]" />{i.label}</CommandItem>)}
        </CommandGroup>
        <CommandGroup heading="Signals">
          {SIGNALS.slice(0, 5).map((s) => <CommandItem key={s.id} value={`${s.id} ${s.instrument}`} onSelect={() => go(`/signals/${s.id}`)}><Radio size={14} className="mr-2 text-[var(--ink-3)]" />{s.instrument} · {s.direction} <span className="ml-auto font-mono text-xs text-[var(--ink-4)]">{s.id}</span></CommandItem>)}
        </CommandGroup>
        <CommandGroup heading="Pages">
          {PAGES.map((p) => <CommandItem key={p.to} value={p.label} onSelect={() => go(p.to)}><FileText size={14} className="mr-2 text-[var(--ink-3)]" />{p.label}</CommandItem>)}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
